// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__YwX8Y","modal_content":"Modal_modal_content__9MYGG","large_modal":"Modal_large_modal__LoB0U"};